import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { 
  fetchPersonnelFolders,
  folderCleanUp,
} from "../../features/folder/folderSlice"; 
import NoCont from "./NoCont";
import InsideHeader from "../../components/InsideHeader"; 
import HowToAddPersonnelModal from "./modal/HowToAddPersonnelModal";
import PersonnelFolderTable from "./PersonnelFolderTable";

export default function Group() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { personnelFolders, fldLoading } = useSelector((state) => state.folder);

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  function handleAddFolder() {
    setopen(true);
  }

  const handleGoBack = () => {
    navigate("/outbox");
  };

  async function handleFetchData() {
    await dispatch(fetchPersonnelFolders());
  }

  async function handleUploadFile() { 
    await navigate("/personnel/add/file-upload");
  }

  useEffect(() => {}, [personnelFolders]);

  useEffect(() => {
    handleFetchData();
    dispatch(folderCleanUp());
  }, []);



  return (
    <>
      <div className="w-full overflow-y-scroll h-full">
    
        <InsideHeader
          title="Personnel Profile"
          subtitle="Manage personnel profile within your institution"
          back={true}
          title1="Personnel"
          title2="personnel Add"
        />

        <div className="mt-[1.25rem] lg:p-10 p-3 lg: h-full bg-white rounded-[10px]">
          {personnelFolders?.length > 0 ? (
            <PersonnelFolderTable
              handleFetchData={handleFetchData}
              handleAddFolder={handleAddFolder}
            />
          ) : (
            <NoCont handleAddFolder={handleAddFolder}  
            handleFetchData={handleFetchData}
            uploadGraduateFile={handleUploadFile}
            open={open}
            handleCancel={handleCancel}
            title="Let’s start by creating a personnel"
            title1="Create personnel to organise your employees"
            btnTitle="Create Personnel"
            />
          )}
        </div>
     
        <HowToAddPersonnelModal
          handleFetchData={handleFetchData}
          uploadGraduateFile={handleUploadFile}
          open={open}
          handleCancel={handleCancel}
        />
        
      </div>
    </>
  );
}
